import { OrthographicCamera, PerspectiveCamera } from 'three';

import { useResize } from '@resn/gozer-vue';

export function useOrthographicCamera(options = {}) {
    const { left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 1000 } = options;

    const camera = new OrthographicCamera(left, right, top, bottom, near, far);

    const resize = () => {
        const { width, height } = viewport;
        camera.left = -width / 2;
        camera.right = width / 2;
        camera.top = height / 2;
        camera.bottom = -height / 2;
        camera.updateProjectionMatrix();
    };

    const viewport = useResize(resize, true);

    return camera;
}

export function usePerspectiveCamera(options = {}) {
    const { fov = 75, aspect = 1, near = 0.1, far = 1000, position = [0, 0, 5] } = options;

    const camera = new PerspectiveCamera(fov, aspect, near, far);
    camera.position.set(...position);

    const resize = () => {
        const { width, height } = viewport;
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
    };

    const viewport = useResize(resize, true);

    return camera;
}
